import Lenis from 'lenis';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initLenis(ctx) {
  const lenis = new Lenis();
  ctx.lenisInstance = lenis;

  const scroller = document.scrollingElement || document.documentElement;

  ScrollTrigger.scrollerProxy(scroller, {
    scrollTop(value) {
      if (arguments.length) {
        lenis.scrollTo(value, { immediate: true });
      }
      return lenis.scroll;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
    pinType: scroller.style.transform ? 'transform' : 'fixed',
  });

  lenis.on('scroll', ScrollTrigger.update);

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };

  requestAnimationFrame(raf);

  ScrollTrigger.addEventListener('refresh', () => lenis.raf(performance.now()));
  ScrollTrigger.refresh();

  return ctx;
}
